import React from 'react';

/**
 * DimensionManager Component
 * 
 * Displays and manages dimension limits for a subscription plan.
 * Shows dimension information like user count limits, report limits, etc.
 * 
 * This component is currently a placeholder for future dimension management features.
 * In a flat-rate or per-user billing model, dimensions are typically read-only
 * since they're managed by the marketplace subscription quantity.
 */
const DimensionManager = ({ subscriptionId, planId }) => {
  // This component is intentionally minimal for now
  // Future enhancements could include:
  // - Displaying current dimension usage vs limits
  // - Showing dimension history
  // - Warning alerts when approaching limits
  
  // For now, we don't display anything since dimension information
  // is already shown in the user management and reports sections
  return null;
};

export default DimensionManager;
